import { AvForm } from 'availity-reactstrap-validation';
import AppContent from 'js/components/AppContent';
import AddressInput from 'js/components/common/AddressInput';
import AddressFeedback from 'js/components/common/AddressInput/AddressFeedback';
import Button from 'js/components/common/Button';
import ErrorDisplay from 'js/components/common/ErrorDisplay';
import SubmitRow from 'js/components/core/Modal/SubmitRow';
import { makeRequest } from 'js/services/Network';
import AppState from 'js/stores/AppState';
import AppUser from 'js/stores/AppUser';
import UserDashboardPageState from 'js/stores/pages/UserDashboardPageState';
import { pick } from 'lodash';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { FormGroup, Label, Modal, ModalBody } from 'reactstrap';
import ActivitiesList from './ActivitiesList';
import Content from './Content';
import DashboardPage from './DashboardPage';
import Sidebar from './Sidebar';

const UserDashboard = () => {
  const [stats, setStats] = React.useState({});
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState('');
  const page = UserDashboardPageState.create();

  useEffect(async () => {
    AppState.setCurrentPage('UserDashboardPage');
    await page.load();
    setStats(page);
  }, []);

  const submitAddress = async () => {
    try {
      setIsSaving(true);
      const response = await makeRequest('address-save', null, pick(AppUser, ['address']));
      setIsSaving(false);
      setError('');
      page.setFirstLogin(false);
      setStats(page);
    } catch (error) {
      console.info(error);
      setIsSaving(false);
      setError(error.response
        ? error.response.data.message || error.response.statusText
        : 'Unknown error occurred');
    }
  }

  return (
    <>
      <UserDashboardPage stats={stats} />
      <Modal isOpen={stats.first_login && !stats.has_address} size="md" className="address-modal" backdropClassName="address-modal-backdrop">
        <ModalBody>
          <div>
            <h2>Welcome <strong>{AppUser.login}</strong>!</h2>
            <p>To fully activate your checkout, please provide the default address to pickup your packages.</p>
          </div>
          <AvForm onValidSubmit={submitAddress}>
            <FormGroup>
              <Label for="address">Address</Label>
              <AddressInput
                name="address"
                id="address"
                showError={false}
                address={AppUser.address}
                onChange={AppUser.address.setAddress}
                placeholder="Your street address"
              />
              <AddressFeedback>Please enter and then select your address.</AddressFeedback>
            </FormGroup>

            <ErrorDisplay>{error}{error && (<><br/>Please try again.</>)}</ErrorDisplay>

            <SubmitRow>
              <Button isLoading={isSaving} autoFocus type="submit">
                Save Address
              </Button>
            </SubmitRow>
          </AvForm>
        </ModalBody>
      </Modal>
    </>
  );
};

const UserDashboardPage = observer(({ stats }) => {

  return (
    <>
      <AppContent className='user-dashboard d-lg-flex align-items-stretch'>
        <Sidebar currentPage='UserDashboardPage' pageState={stats} />
        <Content currentPage='UserDashboardPage'>
          <DashboardPage title='Dashboard'>
            <ActivitiesList stats={stats} />
          </DashboardPage>
        </Content>
      </AppContent>
    </>
  );
});

export default UserDashboard;
